import { useState } from 'react';
import N3ContentLayout from './N3ContentLayout'; 
import N3DataJa from '../../../assets/n3/n3Data.ja.json';
import AdUnit from '../../../components/ads/AdUnit'; // Import AdUnit

const ADS = {
  client: 'ca-pub-2811591266080010',  // <-- replace with your publisher ID
  topSlot: '2331374547',              // <-- replace with your TOP banner slot
  leftSlot: '3859244481',             // <-- LEFT rail slot
  rightSlot: '3034900367',            // <-- RIGHT rail slot
  mobileTopSlot: '3859244481'         // <-- Your specific mobile top ad slot
};

const layoutStyles = {
  page: {
    // MOBILE-FIRST: Single column, centered
    display: 'grid',
    gridTemplateColumns: 'min(960px, 100%)', 
    gap: '12px',
    alignItems: 'start',
    justifyContent: 'center', 
    margin: '0 auto', 
  },
  topBar: {
    maxWidth: 960,
    margin: '0 auto 12px auto',
  },
  center: {
    width: '100%',
    background: '#fff',
    padding: '12px', 
    boxSizing: 'border-box',
    margin: '0', 
    maxWidth: 'none', 
  },
  railWrap: {
    position: 'sticky',
    top: 80,
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
  },
  railBox: {
    width: 160,
  },
};

const cardStyle = {
    padding: '1.5rem',
    margin: '1rem',
    border: '1px solid #ccc',
    borderRadius: '8px',
    cursor: 'pointer',
    textAlign: 'center',
    transition: 'background-color 0.2s, box-shadow 0.2s',
    backgroundColor: '#fff',
    boxShadow: '0 2px 5px rgba(0,0,0,0.05)',
    flexGrow: 1,
};

const cardHoverStyle = {
    backgroundColor: '#f0faff',
    boxShadow: '0 4px 10px rgba(25,118,210,0.1)',
};

const dataMap = {
    ja: N3DataJa,
};


const N3Landing = () => {
    const defaultLang = 'ja'; 
    const years = dataMap[defaultLang].map(entry => entry.year);
    
    const [selectedYear, setSelectedYear] = useState(null);
    const [hoveredYear, setHoveredYear] = useState(null);

    // If a year is selected, render the content layout for that year
    if (selectedYear) {
        return <N3ContentLayout initialYear={selectedYear} />;
    }
    
    // Global Styles (Copied from N3ContentLayout.js to manage responsive layout)
    const globalStyles = `
        /* HIDE ADS RAILS ON SMALL SCREENS */
        @media (max-width: 1200px) {
          .ad-rail {
            display: none !important;
          }
        }
        
        /* DESKTOP 3-COLUMN LAYOUT */
        @media (min-width: 984px) { 
          .N3-page-container {
            /* Revert to 3-column on wide screens */
            grid-template-columns: minmax(0, 1fr) min(960px, 100%) minmax(0, 1fr) !important;
          }
        }
    `;

    // Otherwise, render the year selection cards within the ad layout
    return (
        <div>
            <style dangerouslySetInnerHTML={{ __html: globalStyles }} />
            
            {/* TOP banner (Desktop Ad - centered above the container) */}
            <div style={layoutStyles.topBar}>
                <AdUnit
                    client={ADS.client}
                    slot={ADS.topSlot}
                    // Responsive leaderboard
                    style={{ display: 'block', textAlign: 'center', minHeight: 90 }}
                    format="auto"
                    fullWidth
                />
            </div>

            {/* Main Grid Container */}
            <div className="N3-page-container" style={layoutStyles.page}>
                
                {/* LEFT rail (Column 1 - Desktop Ad Rail) */}
                <div className="ad-rail" style={layoutStyles.railWrap} aria-hidden>
                    <div style={layoutStyles.railBox}>
                        <AdUnit
                            client={ADS.client}
                            slot={ADS.leftSlot}
                            style={{ display: 'block', minHeight: 600 }}
                            format="auto"
                        />
                    </div>
                </div>

                {/* CENTER content (Column 2) */}
                <div style={layoutStyles.center}>
                    
                    {/* MOBILE TOP NON-FIXED BANNER AD (If you have a separate mobile slot for non-content pages) */}
                    <div style={{ marginBottom: '1rem', textAlign: 'center' }}>
                        <AdUnit 
                            client={ADS.client}
                            slot={ADS.mobileTopSlot}
                            format="auto" 
                            fullWidth={true} 
                            style={{ display: 'inline-block', minHeight: '50px', width: '100%' }} 
                        />
                    </div>
                    
                    <h2>Select N3 Examination Year</h2>
                    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '10px', padding: '10px 0' }}>
                        {years.map(year => (
                            <div
                                key={year}
                                onClick={() => setSelectedYear(year)}
                                onMouseEnter={() => setHoveredYear(year)}
                                onMouseLeave={() => setHoveredYear(null)}
                                style={{
                                    ...cardStyle,
                                    ...(hoveredYear === year ? cardHoverStyle : {}),
                                    // Restrict width on large screens so it doesn't span too wide
                                    maxWidth: '250px' 
                                }}
                            >
                                <h3 style={{ margin: '0 0 5px 0', color: '#1976d2' }}>{year}</h3>
                                <p style={{ margin: 0, fontSize: '0.9rem', color: '#666' }}>Start Exam</p>
                            </div>
                        ))}
                    </div>
                </div> 

                {/* RIGHT rail (Column 3 - Desktop Ad Rail) */}
                <div className="ad-rail" style={layoutStyles.railWrap} aria-hidden>
                    <div style={layoutStyles.railBox}>
                        <AdUnit
                            client={ADS.client}
                            slot={ADS.rightSlot}
                            style={{ display: 'block', minHeight: 600 }}
                            format="auto"
                        />
                    </div>
                </div>
            </div>
            
            {/* No fixed confirm button or dialog needed on the landing page */}
            {/* The fixed bottom anchor ad is handled by the overall App.js wrapper/AdSense Auto Ads */}

        </div>
    );
};

export default N3Landing;